import { composeAPI, intoLines } from "../Common/api";
import accessComposition from "./composition";

const firstColumn = (line) => line.split(/\s+/).at(0);

const nonRepeatedNames = (present, name) =>
  present.has(name) ? present : present.add(name);

const parseNamesAsList = (input) => {
  const [_head, ...lines] = intoLines(input);
  return Array.from(lines.map(firstColumn).reduce(nonRepeatedNames, new Set()));
};

const addressColumn = firstColumn;

const singleValueAddress = input =>
  input === '::' ? 0 /*whole IPv6*/ : input; // not an IPv4 address

const sumOrKeep = (total=0, byte, position, all) =>
  all.length === 1 ? singleValueAddress(...all) :
    total + (byte * /*weight*/ Math.pow(255, 4 - position))

const intoByteSumOrKeep = input =>
    input.split('/').at(0)/*only the IP matters*/.split('.').reduce(sumOrKeep, 0)

const compareAddress = (one, another) =>{
  const [oneBytes, anotherBytes] = [intoByteSumOrKeep(one), intoByteSumOrKeep(another)] 
  return oneBytes < anotherBytes
    ? -1
    : oneBytes > anotherBytes
    ? 1
    : 0
}
const sortLineByAddress = (one, another) => {
  const [oneAddress, anotherAddress] = [addressColumn(one), addressColumn(another)];
  return compareAddress(oneAddress, anotherAddress);
}
const sortEntriesByAddress = input => {
  const [head, ...lines] = intoLines(input);
  return [head, ...lines.sort(sortLineByAddress)].join('\n');
}

const loadProfilesSortingEntries = (names) =>
  Promise.all(
    names.map((name) =>
      ifCl.run(`show profile '${name}'`)
        .then((result) => ({ name, result: sortEntriesByAddress(result) }))
    )
  );

const longestNameLength = (namesAndResults) =>
  namesAndResults.reduce(
    (current, { name }) => (name.length > current ? name.length : current),
    0
  );

const extendHeaderAndBodyWithName = (name, result, nameLength) =>
  intoLines(result)
    .map((line, index) =>
      index === 0
        ? `${"NAME".padEnd(nameLength, " ")} ${line}`
        : `${name.padEnd(nameLength, " ")} ${line}`
    )
    .join("\n");

const extendBodyWithName = (name, result, nameLength) =>
  intoLines(result)
    .filter((_, index) => index > 0)
    .map((line) => `${name.padEnd(nameLength, " ")} ${line}`)
    .join("\n");

const newTableWithName =
  (nameLength) =>
  (table, { name, result }, index) =>
    index === 0
      ? extendHeaderAndBodyWithName(name, result, nameLength)
      : [table, extendBodyWithName(name, result, nameLength)].join("\n");

const squashIntoTable = (namesAndResults) =>
  namesAndResults.reduce(
    newTableWithName(longestNameLength(namesAndResults)),
    ""
  );

export const loadAll = ({ cliType }) =>
  ifCl
    .run(`show profile ${cliType}`)
    .then(parseNamesAsList)
    .then(loadProfilesSortingEntries)
    .then(squashIntoTable);

export const composedAPI = composeAPI({ loadAll, ...accessComposition });
